import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { TabsContent, Tabs } from 'ha/components/Tabs';

interface Props {
  contentIndex: number;
  handleChangeContentIndex: (i: number) => void;
  handleChangeSlideIndex: (i: number) => void;
  navigationContent: TabsContent[];
  orientation: 'vertical' | 'horizontal';
  withText: boolean;
}

const useStyles = makeStyles()(theme => ({
  tabsIndicator: {
    display: 'none',
  },
  tabRoot: {
    opacity: 1,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1),
    margin: theme.spacing(0.5),
    minWidth: theme.spacing(7),
    minHeight: theme.spacing(7),
  },
  tabSelected: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
  },
}));

const Navigation: React.FC<Props> = ({
  navigationContent,
  contentIndex,
  handleChangeContentIndex,
  handleChangeSlideIndex,
  orientation,
  withText,
}) => {
  const { classes } = useStyles();

  const tabsContent = React.useMemo(
    () =>
      navigationContent.map(navigationContentItem => ({
        ...navigationContentItem,
        text: withText ? navigationContentItem.text : undefined,
      })),
    [withText, navigationContent],
  );

  return (
    <Tabs
      tabsContent={tabsContent}
      value={contentIndex}
      onChange={(_, value) => {
        handleChangeContentIndex(value);
        handleChangeSlideIndex(0);
      }}
      style="dark"
      centered
      orientation={orientation}
      tabsClasses={{
        indicator: classes.tabsIndicator,
      }}
      tabClasses={{
        root: classes.tabRoot,
        selected: classes.tabSelected,
      }}
      data-test-locator="gallery-tabs"
    />
  );
};

export { Navigation };
